import React from "react";
import styled from "styled-components";

const networks = [
  {
    name: "Asset Chain",
    light: "/assets/img/xend_finance_light.svg",
    dark: "/assets/img/xend_finance_dark.svg",
  },
  {
    name: "Binance Smartchain",
    light: "/assets/img/SVG/binance_light.svg",
    dark: "/assets/img/SVG/binance_dark.svg",
  },
  {
    name: "Celo",
    light: "/assets/img/SVG/celo_light.svg",
    dark: "/assets/img/SVG/celo_dark.svg",
  },
  {
    name: "Arbitrum",
    light: "/assets/img/SVG/arbitrum_light.svg",
    dark: "/assets/img/SVG/arbitrum_dark.svg",
  },
  {
    name: "Polygon",
    light: "/assets/img/SVG/polygon_light.svg",
    dark: "/assets/img/SVG/polygon_dark.svg",
  },
  {
    name: "Heco Chain",
    light: "/assets/img/SVG/heco_chain_light.svg",
    dark: "/assets/img/SVG/heco_chain_dark.svg",
  },
  {
    name: "Avalanche",
    light: "/assets/img/SVG/avalanche_light.svg",
    dark: "/assets/img/SVG/avalanche_dark.svg",
  },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: transparent;
  padding: 2rem 1rem;
  z-index: 100;
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.black};
  margin-bottom: 2rem;
  font-size: clamp(1.75rem, 4vw, 3rem);
  text-align: center;
`;

const NetworksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1.5rem;
  width: 100%;
  max-width: 1200px;
  justify-items: center;
  align-items: center;
`;

const NetworkItem = styled.div`
  display: flex;
  /* flex-direction: column; */
  gap: 10px;
  align-items: center;
  /* justify-content: center; */
  background-color: ${({ theme }) => theme.gray26};
  border: 1px solid #3a547a;
  border-radius: 12px;
  padding: 1rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
  max-width: 160px;
  text-align: center;

  &:hover {
    transform: translateY(-4px) scale(1.03);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  }
`;

const NetworkIcon = styled.img`
  width: 32px;
  height: 32px;
  margin-bottom: 0.5rem;

  @media (min-width: 768px) {
    width: 48px;
    height: 48px;
    margin-bottom: 0.75rem;
  }
`;

const NetworkName = styled.span`
  color: ${({ theme }) => theme.black};
  font-size: clamp(0.85rem, 1.5vw, 1rem);
  font-weight: 500;
`;

const SupportedNetworks = ({ currentTheme }) => {
  return (
    <Container>
      <Title>Supported Networks</Title>
      <NetworksGrid>
        {networks.map((network) => (
          <NetworkItem key={network.name}>
            <NetworkIcon
              src={currentTheme === "light" ? network.light : network.dark}
              alt={`${network.name} icon`}
            />
            <NetworkName>{network.name}</NetworkName>
          </NetworkItem>
        ))}
      </NetworksGrid>
    </Container>
  );
};

export default SupportedNetworks;
